import { IconDefinition } from '@fortawesome/angular-fontawesome';

export const faChevronRight: IconDefinition = {
  prefix: 'fac',
  iconName: 'chevron-right',
  icon: [5, 9, [], '', 'M0 8.33333V0L4.16667 4.16667L0 8.33333Z'],
};
